import { headerStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { css } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";


headerStyles. shareEntityButtonStyles = {
    button: {
        buttonType: "outline",
        variant: "secondary",
        css: css`
        padding: 10px 34px;
    `,
    },
}
headerStyles. buttonsHiddenContainer = {
    below: "lg",
    css: css`
    button {
        margin-left: 10px;
    }
    `,
}
headerStyles. menuHiddenContainer = {
    above: "md",
    css: css`
    
    ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                button {
                    background: none !important;
                }
                
                `,
                css`
                button {
                    background: none !important;
                }
                `,
                css`
                button {
                    background: none !important;
                }
                `,
                null,
                null,
            ])}
    `,
}
headerStyles.buttonGridItem = {
    css: css`
        justify-content: flex-end;
    `,
    width: [2, 2, 1, 6, 6],
    style: { marginTop: "11px" },
}
headerStyles.titleGridItem = {
    width: [10, 10, 11, 6, 6],
    style: { marginTop: "20px" },
}